/** Pure formatting for records, rates and sample sizes. Every number keeps its n. */

export const PROVISIONAL_BELOW = 20;

export function formatRecord(b: { wins: number; losses: number; draws: number }): string {
  return b.draws > 0 ? `${b.wins}-${b.losses}-${b.draws}` : `${b.wins}-${b.losses}`;
}

export function winRateText(rate: number | null): string {
  return rate === null ? '—' : `${Math.round(rate * 100)}%`;
}

export function sampleLabel(n: number): string {
  return `${n} ${n === 1 ? 'match' : 'matches'}`;
}

/**
 * A win rate on a handful of games is noise wearing a number's clothes, so the
 * UI says so rather than letting the reader assume otherwise.
 */
export function provisionalNote(n: number): string | null {
  if (n === 0) return 'No matches yet';
  if (n < PROVISIONAL_BELOW) return `Provisional — ${n} of ${PROVISIONAL_BELOW} matches`;
  return null;
}

export function resultTone(result: string): 'win' | 'loss' | 'draw' {
  if (result === 'win') return 'win';
  if (result === 'loss' || result === 'concede') return 'loss';
  return 'draw';
}

export function confidenceText(confidence: number | null): string {
  return confidence === null ? '—' : `${Math.round(confidence * 100)}%`;
}

/** Published metagame share, which arrives as a percent rather than a fraction. */
export function shareText(share: number | null): string {
  return share === null ? '—' : `${share.toFixed(1)}%`;
}
